<div [formGroup]="form">
  <mat-form-field *ngIf="!readonly" appearance="outline">
    <mat-label>{{attribute.name}}</mat-label>
    <input matInput [matDatepicker]="picker" [formControlName]="attribute.identifier" [required]="attribute.mandatory">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</div>

